<template>
    <!--@formatter:off-->
    <li class="ex_sel3" style="display: list-item;">
        <div class="info_select">
            <div class="bx_limit">
                <span class="tit_inp_lmt">{{$t('common_limitCount')}}</span>
                <TextInput type="text"
                           wrapper-class="bx_inp_lmt"
                           input-class="inp_lmt"
                           label-class="inp_placeholder"
                           :id="limitId"
                           :only-number="true"
                           :maxlength="3"
                           v-model="limit"
                />
            </div>
            <div class="bx_limit">
                <span class="tit_inp_lmt">{{$t('common_reservedLimitCount')}}</span>
                <TextInput type="text"
                           wrapper-class="bx_inp_lmt"
                           input-class="inp_lmt"
                           label-class="inp_placeholder"
                           :id="reservedLimitId"
                           :only-number="true"
                           :maxlength="3"
                           v-model="reservedLimit"
                />
            </div>
        </div>
    </li>
    <!--@formatter:on-->
</template>

<script>
    import TextInput from '@iamteacherpc/components/common/TextInput.vue';

    export default {
        name: 'SurveyQuestionAnswerFcfsOptionEditor',
        components: {TextInput},

        props: {
            questionIndex: {
                type: Number,
                required: true,
            },

            answerIndex: {
                type: Number,
                required: true,
            },
        },

        computed: {
            ...createComputed('limit'),
            ...createComputed('reservedLimit'),

            limitId() {
                return `limit-${this.questionIndex}-${this.answerIndex}`;
            },

            reservedLimitId() {
                return `reserved-limit-${this.questionIndex}-${this.answerIndex}`;
            },
        },

        methods: {
            getStorePath() {
                return `form.questions[${this.questionIndex}].answers[${this.answerIndex}]`;
            },
        },
    };

    function createComputed(key) {
        return {
            [key]: {
                get() {
                    return this.$store.getters['surveyEditor/getField'](`${this.getStorePath()}.${key}`);
                },
                set(newValue) {
                    this.$store.commit('surveyEditor/updateField', {
                        path: `${this.getStorePath()}.${key}`,
                        value: newValue,
                    });
                },
            },
        };
    }
</script>

<style scoped>

</style>
